<script>
  import RangeInput from './rangeInput.vue'
  import VerifyField from './verifyField'
  import RelationField from './fields/relationField.vue'
  import QuoteField from './fields/quoteField.vue'
  import STree from './fields/tree.vue'
  import NodeRender from './mdwfCompUtil/nodeRender.vue'

    export default {
        props: ['fieldData','allFieldsVal','doubleCallFlag'],
        components: {
          RangeInput,
          VerifyField,
          RelationField,
          QuoteField,
          STree,
          NodeRender
        },
        data(){
          return {
            ischangeOnSelect:false
          }
        },
        created(){
        },
        render(h){
          return this.renderNode(h,this.fieldData)
        },
        methods: {
            renderNode(h,fieldData) {
              let isNoVerify = false
              let node
              // '0',//单行文本类型 '1',//多行文本框类型 '2',//布尔类型 '3',//单选类型'4',//复选类型 '5',//整数类型
              // '6',//实数类型 '7',//百分比类型 '8',//电话类型'9',//自动编号类型 '10',//日期类型 (年月日)'11',//日期时间类型(年月日时分秒)
              //  '12',//邮箱类型 '13',//网页地址（链接）类型 '14',//省市区类型 '15',//图片类型 '16',//附件类型 '17',//关联对象 '18',//引用字段
              //     '19',//主子明细 '20',//计算类型  '21',//定位类型

              if (fieldData.fieldType === '0'||fieldData.fieldType === '1'||
                  fieldData.fieldType === '8'||fieldData.fieldType === '9'||
                  fieldData.fieldType === '12'|| fieldData.fieldType === '13' ||
                  (fieldData.fieldType === '20' && fieldData.calcResultType === "0")||
                  fieldData.fieldType === '21'||fieldData.fieldType === "5"||fieldData.fieldType === "6"){
                  let eleType = 'Input'
                  let thisType = 'text'
                  if(fieldData.fieldType === "5"){
                    thisType= 'number'
                  }else if(fieldData.fieldType === "1"){
                    thisType= 'textarea'
                  }else if(fieldData.fieldType == "6"){
                    thisType= 'number'
                  }
                  let maxlength = fieldData.maxLength || ''
                  if(fieldData.fieldCname=='cust_phone'){
                    // console.log('所有字段的值==',this.allFieldsVal)
                    // 双呼
                    node = h('NodeRender',{
                      props:{
                        placeholder:"请输入"+fieldData.fieldName,
                        value:fieldData.value || "",
                        allFieldsVal: this.allFieldsVal,
                        encryption: this.allFieldsVal.encryption_id||'0',
                        doubleCallFlag: this.doubleCallFlag,
                        width:"auto",
                        maxlength
                      },
                      on: {
                        'on-change': e => {
                            fieldData.value = e.target.value
                            this.$emit('change',{
                              ...fieldData,
                              value:e.target.value
                            })
                          }
                      }
                    })
                    return node;
                  }
                  let showLimit = false
                  if(thisType == 'textarea'&&maxlength){
                    showLimit = true
                  }
                  node = h(eleType, {
                      props: {
                          placeholder:"请输入"+fieldData.fieldName,
                          value:fieldData.value || "",
                          width:"auto",
                          type: thisType,
                          // showWordLimit: showLimit,
                          maxlength
                      },
                      on: {
                          'on-change': e => {
                              fieldData.value = e.target.value
                              this.$emit('change',{
                                ...fieldData,
                                value:e.target.value
                              })
                              // this.$set(this.fieldData,'value',e.target.value)
                          }
                      }
                  })
              }
              if(fieldData.fieldType === '7'){
                let maxlength = fieldData.maxLength || ''
                node = h('InputNumber', {
                    props: {
                        placeholder:"请输入"+fieldData.fieldName,
                        value:fieldData.value || "",
                        width:"auto",
                        // showWordLimit: showLimit,
                        maxlength,
                        formatter: value => {
                          if(value&&(typeof value == 'string')){
                            value = value.replace('%', '')
                          }
                          return value?`${value}%`:''
                        },
                        parser: value => {
                          if(value&&(typeof value == 'string')){
                            return value.replace('%', '')
                          }
                        }
                    },
                    on: {
                        'on-change': e => {
                            fieldData.value = e
                            this.$emit('change',{
                              ...fieldData,
                              value:e
                            })
                            // this.$set(this.fieldData,'value',e.target.value)
                        }
                    }
                })
              }
              if ((fieldData.fieldType === '2'||fieldData.fieldType === '3')) {
                
                var optionNodes = []
                fieldData.options = fieldData.options || []
                //radio形式
                if(fieldData.fieldType === '2'|| (fieldData.fieldType === '3'&&fieldData.checkId ==1)){
                  if(fieldData.fieldCname=='encryption'){
                    console.log()
                  }
                  fieldData.options.forEach(item => {
                    optionNodes.push(
                      h('Radio', { props: { label: item.value } }, item.key)
                    )
                  })
                  let selectNode = h(
                    'RadioGroup',
                    {
                        props: {
                            value:fieldData.value || "",
                            vertical: true
                        },
                        on: {
                            'on-change': value => {
                              fieldData.value = value;
                              this.$emit('change',{
                                ...fieldData,
                                value:value
                              })
                            }
                        }
                    },
                    optionNodes
                  ) 
                  node = selectNode
                }else{
                  fieldData.options.forEach(item => {
                    optionNodes.push(
                        h('Option', { props: { value: item.value } }, item.key)
                    )
                  })
                  let selectNode = h(
                    'Select',
                    {
                        props: {
                            placeholder:"请选择"+fieldData.fieldName,
                            value:fieldData.value || "",
                            clearable:true,
                              },
                        on: {
                            'on-change': value => {
                              fieldData.value = value
                              this.$emit('change',{
                                ...fieldData,
                                value:value
                              })
                            }
                        }
                    },
                    optionNodes
                  ) 
                  node = selectNode
                }
                if(true || (!fieldData.relation || !fieldData.relation.length)){ 
                  // node = selectNode
                }else{//有需要联动的组件时(这种渲染形式不需要了)
                  let relationNodes = []
                  for(let i in fieldData.relation){
                    let item = fieldData.relation[i]
                    if(item.value == fieldData.value){
                      for(let i in item.relation){
                        item.relation[i]._isHide = false
                        relationNodes.push(this.renderNode(h,item.relation[i]))
                      }
                    }else{
                      for(let k in item.relation){
                        item.relation[i]._isHide = true
                      }
                    }
                  }
                  console.log(fieldData.value,relationNodes)
                  //单独包裹校验壳子
                  let parentNode = h('VerifyField',{
                    props:{
                      fieldData
                    }
                  },[selectNode])
                  //不包裹校验壳子
                  isNoVerify = true
                  node = h('div',{

                  },[parentNode,...relationNodes])
                }
                  
              }

              if (fieldData.fieldType === '4') {
                  let optionNodes = []
                  if(fieldData.checkId ==1){
                    fieldData.options.forEach(item => {
                      optionNodes.push(
                        h('div',{
                          style: {
                            'padding-bottom':'5px'
                          }
                        },
                          [h('Checkbox', { props: { label: item.value } }, item.key)]
                        )
                      )
                    })
                    node = h(
                      'CheckboxGroup',
                      {
                          props: {
                              value:fieldData.value || []
                          },
                          on: {
                              'on-change': value => {
                                  this.$emit('change',{
                                    ...fieldData,
                                    value:value
                                  })
                                  fieldData.value = value;
                              }
                          }
                      },
                      optionNodes
                    )
                  }else{
                    fieldData.options.forEach(item => {
                      optionNodes.push(
                          h('Option', { props: { value: item.value } }, item.key)
                      )
                    })
                    node = h(
                      'Select',
                      {
                          props: {
                              placeholder:"请选择"+fieldData.fieldName,
                              value:fieldData.value || [],
                              multiple:true
                          },
                          on: {
                              'on-change': value => {
                                  this.$emit('change',{
                                    ...fieldData,
                                    value:value
                                  })
                                  fieldData.value = value;
                              }
                          }
                      },
                      optionNodes
                    )
                  }
                  
              }

              if (fieldData.dateType == 0 && (fieldData.fieldType === '10')){
                  // 日期
                  let options = {}
                  if(fieldData.selectScope == 1){
                    options = {
                      disabledDate (date) {
                        return date && date.valueOf() < Date.now() - 86400000;
                      }
                    }
                  }
                  node = h('DatePicker', {
                      props: {
                          fieldType: 'daterange',
                          placeholder:"请选择"+fieldData.fieldName,
                          value: fieldData.value,
                          type: fieldData.timeType == 1?'daterange':'date',
                          options
                      },
                      on: {
                        'on-change': (value) => {
                              this.$emit('change',{
                                ...fieldData,
                                value:value
                              })
                              fieldData.value = value;
                          }
                      }
                  })
              }

              if (fieldData.dateType == 1 && (fieldData.fieldType === '10')){
                  // 日期时间
                  let options = {}
                  if(fieldData.selectScope == 1){
                    options = {
                      disabledDate (date) {
                        return date && date.valueOf() < Date.now() - 86400000;
                      }
                    }
                  }
                  node = h('DatePicker', {
                      props: {
                          fieldType: 'datetimerange',
                          placeholder:"请选择"+fieldData.fieldName,
                          format:"yyyy-MM-dd HH:mm:ss",
                          value: this.fieldData.value,
                          type: fieldData.timeType == 1?'datetimerange':'datetime',
                          options
                      },
                      on: {
                          'on-change': value => {
                              this.$emit('change',{
                                ...fieldData,
                                value:value
                              })
                              fieldData.value = value
                          }
                      }
                  })
              }

              if ((fieldData.fieldType === '20' && fieldData.calcResultType === "6")){
                  node = h('RangeInput', {
                      props: {
                          value: fieldData.value,
                          title: fieldData.fieldName,
                          placeholder:"请输入"+fieldData.fieldName,
                      },
                      on: {
                          'change': value => {
                            this.$emit('change',{
                              ...fieldData,
                              value:value
                            })
                            fieldData.value = value
                          }
                      }
                  }) 
              }

              if((fieldData.fieldType === '20' && fieldData.calcResultType === "7")){
                node = h('RangeInput', {
                    props: {
                        value: fieldData.value,
                        title: fieldData.fieldName,
                        placeholder:"请输入"+fieldData.fieldName,
                        unit: '%'
                    },
                    on: {
                        'change': value => {
                          this.$emit('change',{
                            ...fieldData,
                            value:value
                          })
                          fieldData.value = value
                        }
                    }
                }) 
              }

              if(fieldData.fieldType === "17"){
                node = h('RelationField', {
                    props: {
                        value: fieldData.value,
                        title: fieldData.fieldName,
                        placeholder:"请输入"+fieldData.fieldName,
                        fieldData
                    },
                    on: {
                        'change': value => {
                          this.$emit('change',{
                            ...fieldData,
                            value:value.value,
                            relationFieldData: value
                          })
                          fieldData.value = value.value
                        }
                    }
                })
              }
              // 引用
              if(fieldData.fieldType === "18"){
                node = h('QuoteField', {
                    props: {
                        value: fieldData.value,
                    }
                })
              }
              //树结构
              if(fieldData.fieldType === "22"){
                console.log('树结构data',fieldData)
                let value = []
                if(typeof fieldData.value === 'string'){
                  value = fieldData.value.split(',')
                }else {
                  value = [...fieldData.value]
                }
                node = h('STree', {
                    props: {
                        value,
                        title: fieldData.fieldName,
                        fieldData,
                        cascaderOptions: JSON.parse(fieldData.dicCode)
                    },
                    on: {
                        'on-change': value => {
                          fieldData.value = value.join(',')//value.map(item => item.value).join(',')
                          this.$emit('change',{
                            ...fieldData,
                            _value:value
                          })
                          console.log(value,fieldData.value)
                        }
                    }
                })
              }
              return node
              // if(isNoVerify){
              //   return node
              // }else{
              //   return h('VerifyField',{
              //     props: {
              //       fieldData
              //     }
              //   },[node]);
              // }
          }
        }
        

    }
</script>

<style scoped>

</style>
